(function () {
  'use strict';

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return 'LE ' + parts[0] + '.' + parts[1];
  }

  function updateSummary() {
    var total = 0;
    var original = 0;

    document.querySelectorAll('.bundle-checkbox').forEach(function(cb) {
      if (cb.checked) {
        total += parseInt(cb.dataset.price, 10);
        original += parseInt(cb.dataset.originalPrice || cb.dataset.price, 10);
      }
    });

    var savings = original - total;

    var elTotal = document.getElementById('cs-total');
    var elOriginal = document.getElementById('cs-original');
    var elSavings = document.getElementById('cs-savings');

    if (elTotal) elTotal.textContent = formatMoney(total);
    if (elOriginal) elOriginal.textContent = savings > 0 ? formatMoney(original) : '';
    if (elSavings) elSavings.textContent = formatMoney(savings > 0 ? savings : 0);
  }

  function showToast(msg) {
    var toast = document.getElementById('cs-toast');
    if (!toast) return;
    var textEl = toast.querySelector('.cs-toast__text');
    if (textEl) textEl.textContent = msg || 'تمت الإضافة للسلة!';
    toast.classList.add('show');
    setTimeout(function() { toast.classList.remove('show'); }, 3000);
  }

  function openCartDrawer() {
  window.location.href = '/cart';
}

  async function addItemsToCart(items) {
    var btn = document.getElementById('cs-add-all-btn');
    var btnText = btn ? btn.querySelector('.btn-text') : null;
    var originalText = btnText ? btnText.textContent : '';

    if (btn) btn.style.opacity = '0.7';
    if (btnText) btnText.textContent = 'جاري الإضافة...';

    try {
      for (var i = 0; i < items.length; i++) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [items[i]] })
        });
      }

      showToast('تمت إضافة المنتجات للسلة! 🎉');

      setTimeout(function() {
        openCartDrawer();
      }, 800);

    } catch (err) {
      console.error('[Cross-Sell]', err);
      showToast('حدث خطأ، حاول مجدداً');
    } finally {
      if (btn) btn.style.opacity = '1';
      if (btnText) btnText.textContent = originalText;
    }
  }

  function init() {
    var section = document.getElementById('cross-sell-bundle');
    if (!section) return;

    updateSummary();

    section.querySelectorAll('.bundle-checkbox:not([disabled])').forEach(function(cb) {
      cb.addEventListener('change', updateSummary);
    });

    var btn = document.getElementById('cs-add-all-btn');
    if (btn) {
      btn.addEventListener('click', function() {
        var items = [];

        section.querySelectorAll('.bundle-checkbox').forEach(function(cb) {
          if (cb.checked && cb.dataset.variantId) {
            var item = {
              id: parseInt(cb.dataset.variantId, 10),
              quantity: 1
            };
            if (cb.dataset.discount) {
              item.properties = { 'خصم': cb.dataset.discount + '%' };
            }
            items.push(item);
          }
        });

        if (items.length === 0) {
          showToast('اختر منتجاً على الأقل');
          return;
        }

        addItemsToCart(items);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();